// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");

function exact(squareFeet) {
  return {
    squareFeet: squareFeet,
    squareFeetRange: false,
    minSquareFeet: undefined,
    maxSquareFeet: undefined
  };
}

function range(minSquareFeet, maxSquareFeet) {
  return {
    squareFeet: undefined,
    squareFeetRange: true,
    minSquareFeet: minSquareFeet,
    maxSquareFeet: maxSquareFeet
  };
}

function hasInput(squareFeetState) {
  if (squareFeetState.squareFeetRange) {
    if (Stdlib_Option.isSome(squareFeetState.minSquareFeet)) {
      return true;
    } else {
      return Stdlib_Option.isSome(squareFeetState.maxSquareFeet);
    }
  } else {
    return Stdlib_Option.isSome(squareFeetState.squareFeet);
  }
}

function toInput(squareFeetState) {
  return {
    exactSquareFeet: squareFeetState.squareFeetRange ? undefined : ({
        squareFeet: squareFeetState.squareFeet
      }),
    squareFeetRange: squareFeetState.squareFeetRange ? ({
        maxSquareFeet: squareFeetState.maxSquareFeet,
        minSquareFeet: squareFeetState.minSquareFeet
      }) : undefined
  };
}

let empty = {
  squareFeet: undefined,
  squareFeetRange: false,
  minSquareFeet: undefined,
  maxSquareFeet: undefined
};

exports.empty = empty;
exports.exact = exact;
exports.range = range;
exports.hasInput = hasInput;
exports.toInput = toInput;
/* No side effect */
